import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseService } from "../../../server/supabase/base-supabase-service";
import type { UUID } from "../../../utils/uuid";
import type { FollowUpDetails } from "./types";

export type FollowUp = Database["public"]["Tables"]["follow_up"]["Row"];

export type MomentExistingFollowUps = {
  id: UUID;
  account_id: UUID;
  follow_ups: {
    id: UUID;
    account_id: UUID;
    channel: FollowUpDetails["channel"];
    schedule: FollowUpDetails["schedule"];
    title: string;
    status: FollowUpDetails["status"];
    config: FollowUpDetails["config"];
    immediate: boolean;
    timezone?: string | null;
  }[];
};

export class SupabaseFollowUpService extends SupabaseService<"follow_up"> {
  table = "follow_up" as const;
}
